import { useCallback } from "react";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export default function usePartShopifyUrl(partId: string) {
  const { get } = useApiHelper();

  const fetchShopifyUrl = useCallback(async (): Promise<string | null> => {
    try {
      const response = await get<DefaultResponseWithData<string>>(`/part/${partId}/shopify-url`);
      return response?.data ?? null;
    } catch {
      return null;
    }
  }, [partId]);

  return { fetchShopifyUrl };
}
